import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRightCircle, LayoutGrid } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { HERO_PHOTO } from "@/content/site";
import { useCustomer } from "@/context/CustomerContext";
import { useAuth } from "@/context/AuthContext";

export default function Accedi() {
  const navigate = useNavigate();
  const { session, slug } = useCustomer();
  const { user } = useAuth();
  useEffect(() => { document.title = "Accedi | Tavoline"; }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: colors.bg }}>
      <div style={{ flex: 1, minHeight: "48vh", display: "flex", flexDirection: "column", justifyContent: "flex-end", backgroundImage: `linear-gradient(rgba(26,24,21,0.15), rgba(26,24,21,0.85)), url(${HERO_PHOTO})`, backgroundSize: "cover", backgroundPosition: "center", padding: spacing.xl }}>
        <div style={{ ...type.sansSemi, fontSize: 12, letterSpacing: 2, color: "rgba(255,255,255,0.85)", marginBottom: spacing.sm }}>ORDINA DAL TAVOLO</div>
        <div style={{ ...type.serif, fontSize: 40, lineHeight: "44px", color: "#fff" }}>Il menu del<br />tuo ristorante</div>
        <div style={{ ...type.sans, fontSize: 16, color: "rgba(255,255,255,0.9)", marginTop: spacing.sm }}>Dal tavolo alla cucina.</div>
      </div>

      <div style={{ background: colors.bg, padding: spacing.lg, display: "flex", flexDirection: "column", gap: spacing.md, borderTopLeftRadius: radius.lg, borderTopRightRadius: radius.lg, marginTop: -radius.lg, maxWidth: 640, width: "100%", alignSelf: "center" }}>
        <div style={{ ...type.serif, fontSize: 30, color: colors.ink, textAlign: "center", marginBottom: spacing.xs }}>Tavoline</div>

        {session && slug ? (
          <button data-testid="resume-session-button" onClick={() => navigate(`/m/${slug}/menu`)} style={{ display: "flex", alignItems: "center", background: colors.accentSoft, border: "none", borderRadius: radius.lg, padding: spacing.md, gap: spacing.md, textAlign: "left" }}>
            <div style={{ flex: 1 }}>
              <div style={{ ...type.sansSemi, fontSize: 12, color: colors.accent }}>Sessione attiva · Tavolo {session.etichetta}</div>
              <div style={{ ...type.serif, fontSize: 18, color: colors.ink, marginTop: 2 }}>Riprendi come {session.guest_name}</div>
            </div>
            <ArrowRightCircle size={28} color={colors.accent} />
          </button>
        ) : null}

        <button data-testid="customer-entry-button" onClick={() => window.open("/m/demo", "_blank", "noopener")} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: spacing.sm, background: colors.accent, border: "none", height: 56, borderRadius: radius.md }}>
          <LayoutGrid size={20} color={colors.onAccent} />
          <span style={{ ...type.sansSemi, fontSize: 17, color: colors.onAccent }}>Prova un menu di esempio</span>
        </button>

        <button data-testid="staff-entry-button" onClick={() => navigate(user ? "/staff/kds" : "/staff/login")} style={{ display: "flex", alignItems: "center", justifyContent: "center", background: colors.surface, height: 52, borderRadius: radius.md, border: `1px solid ${colors.line}` }}>
          <span style={{ ...type.sansMedium, fontSize: 15, color: colors.ink }}>{user ? "Vai alla cucina (KDS)" : "Accesso staff"}</span>
        </button>

        <button data-testid="accedi-footer-chi-sono" onClick={() => navigate("/chi-sono")} style={{ background: "none", border: "none", ...type.sans, fontSize: 12, color: colors.inkMuted, textDecoration: "underline", marginTop: spacing.xs }}>
          Tavoline — costruito da Mariana Radova
        </button>
      </div>
    </div>
  );
}
